import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのSoftwareロゴアイコン
 */
export function ProductLogoMediumSoftware({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fill="#FCFCFD"
        d="M11.4704 9.97021C10.6907 9.97021 10.0586 10.6079 10.0586 11.3945V22.7892C10.0586 23.5758 10.6907 24.2135 11.4704 24.2135H11.7057C11.9656 24.2135 12.1762 24.001 12.1762 23.7388V13.531C12.1762 12.7444 12.8083 12.1067 13.588 12.1067H23.7057C23.9656 12.1067 24.1762 11.8941 24.1762 11.6319V11.3945C24.1762 10.6079 23.5442 9.97021 22.7645 9.97021H11.4704Z"
      />
      <path
        fill="#FCFCFD"
        d="M14.9998 13.531C14.2201 13.531 13.588 14.1687 13.588 14.9554V26.35C13.588 27.1367 14.2201 27.7744 14.9998 27.7744H15.2351C15.495 27.7744 15.7057 27.5618 15.7057 27.2996V17.0919C15.7057 16.3052 16.3377 15.6675 17.1174 15.6675H27.2351C27.495 15.6675 27.7057 15.455 27.7057 15.1928V14.9554C27.7057 14.1687 27.0736 13.531 26.2939 13.531H14.9998Z"
      />
      <path
        fill="#57D7D9"
        d="M17.1174 18.5162C17.1174 17.7296 17.7495 17.0919 18.5292 17.0919H29.8233C30.603 17.0919 31.2351 17.7296 31.2351 18.5162V29.9109C31.2351 30.6975 30.603 31.3352 29.8233 31.3352H18.5292C17.7495 31.3352 17.1174 30.6975 17.1174 29.9109V18.5162Z"
      />
    </svg>
  );
}
